export const admin_routes = [
  {
    path: "/login",
    name: "Login",
    meta: { title: "Login" },
    component: () => import("@/views/admin/pages/Login"),
  },
  {
    path: "/logout",
    name: "Logout",
    meta: { title: "Logout" },
    component: () => import("@/views/admin/pages/Login"),
  },
  {
    path: "/",
    component: () => import("@/views/admin/Layout"),
    meta: {
      middleware: "advisor-auth",
      title: "Agent Panel",
    },
    children: [
      {
        path: "",
        name: "AdminDashboard",
        meta: {
          title: "Agent Dashboard",
        },
        component: () => import("@/views/admin/pages/Dashboard"),
      },
      {
        path: "business",
        name: "BusinessListing",
        meta: {
          title: "Motor Policy",
        },
        component: () => import("@/views/admin/pages/Business/Index"),
      },
      {
        path: "health",
        name: "Health",
        meta: {
          title: "Health Policy",
        },
        component: () => import("@/views/admin/pages/XMotor/Health"),
      },
      {
        path: "Travel",
        name: "Travel",
        meta: {
          title: "Travel Policy",
        },
        component: () => import("@/views/admin/pages/XMotor/Travel"),
      },
      {
        path: "NonMotor",
        name: "NonMotor",
        meta: {
          title: "NonMotor Policy",
        },
        component: () => import("@/views/admin/pages/XMotor/NonMotor"),
      },
      {
        path: "Life",
        name: "Life",
        meta: {
          title: "Life Policy",
        },
        component: () => import("@/views/admin/pages/XMotor/Life"),
      },
      {
        path: "Other",
        name: "Other",
        meta: {
          title: "Other Policy",
        },
        component: () => import("@/views/admin/pages/XMotor/Other"),
      },
      {
        path: "renewal",
        name: "RenewalListing",
        meta: {
          title: "Motor Renewal Policy",
        },
        component: () => import("@/views/admin/pages/Renewal/Index"),
      },
      {
        path: "renewal/health",
        name: "RenewalHealth",
        meta: {
          title: "Health Renewal Policy",
        },
        component: () => import("@/views/admin/pages/Renewal/Health"),
      },
      {
        path: "renewal/NonMotor",
        name: "RenewalNonMotor",
        meta: {
          title: "NonMotor Renewal Policy",
        },
        component: () => import("@/views/admin/pages/Renewal/NonMotor"),
      },
      {
        path: "renewal/Life",
        name: "RenewalLife",
        meta: {
          title: "Life Renewal Policy",
        },
        component: () => import("@/views/admin/pages/Renewal/Life"),
      },
      {
        path: "renewal/Other",
        name: "RenewalOther",
        meta: {
          title: "Other Renewal Policy",
        },
        component: () => import("@/views/admin/pages/Renewal/Other"),
      },
      {
        path: "ledger",
        name: "AgentLedger",
        meta: {
          title: "Agent Ledger",
        },
        component: () => import("@/views/admin/pages/Ledger/Index"),
      },
      {
        path: "ledgerview/:id",
        name: "LedgerView",
        meta: {
          title: "Ledger View",
        },
        component: () => import("@/views/admin/pages/Ledger/Ledgerview"),
      },
    ],
  },
];
